import logo200Image from '../assets/img/logo/logo_300.png';
import PropTypes from 'prop-types';
import React from 'react';
import AuthService from '../services/AuthService';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import queryString from 'query-string';

class AuthForm extends React.Component {
  state = {
    inputValue: "default",
  };

  updateInputValue = event => {
    this.setState({
      inputValue: event.target.value
    });
  }

  get isLogin() {
    return this.props.authState === STATE_LOGIN;
  }

  get isVerify() {
    return this.props.authState === STATE_VERIFY;
  }

  changeAuthState = authState => event => {
    event.preventDefault();

    this.props.onChangeAuthState(authState);
  };

  handleSubmit = event => {
    let auth = new AuthService();
    if (this.isLogin) {
      auth.login(this.state.inputValue);
    } else {
      let query = queryString.parse(window.location.search);
      auth.verify(query.id, this.state.inputValue);
    }
  };

  renderButtonText() {
    const { buttonText } = this.props;

    if (!buttonText && this.isLogin) {
      return 'Login';
    }

    if (!buttonText && this.isVerify) {
      return 'Verify';
    }

    return buttonText;
  }

  keyDown(e) {
    if (e.key === 'Enter') {
      this.handleSubmit();
      e.preventDefault();
    }
  }

  render() {
    const {
      showLogo,
      usernameLabel,
      usernameInputProps,
      otpLabel,
      otpInputProps,
      children,
      onLogoClick,
    } = this.props;

    return (
      <Form onSubmit={this.handleSubmit}>
        {showLogo && (
          <div className="text-center pb-4">
            <img
              src={logo200Image}
              className="rounded"
              style={{ width: 75, height: 75, cursor: 'pointer' }}
              alt="logo"
              onClick={onLogoClick}
            />
          </div>
        )}
        {this.isLogin ?
        <FormGroup>
          <Label for={usernameLabel}>{usernameLabel}</Label>
            <Input onKeyDown={e => this.keyDown(e)} {...usernameInputProps} onChange={this.updateInputValue} />
        </FormGroup> :
         <FormGroup>
           <Label for={otpLabel}>{otpLabel}</Label>
           <Input onKeyDown={e => this.keyDown(e)} {...otpInputProps} onChange={this.updateInputValue} />
        </FormGroup>}
        {/* {this.isLogin &&
        <FormGroup check>
          <Label check>
            <Input type="checkbox" />{' '}
            Remember me
          </Label>
        </FormGroup> } */}
        <Button
          size="lg"
          className="bg-gradient-theme-left border-0"
          block
          onClick={ event => this.handleSubmit()}>
          {this.renderButtonText()}
        </Button>

        {children}
      </Form>
    );
  }
}

export const STATE_LOGIN = 'LOGIN';
export const STATE_VERIFY = 'VERIFY';

AuthForm.propTypes = {
  authState: PropTypes.oneOf([STATE_LOGIN, STATE_VERIFY]).isRequired,
  showLogo: PropTypes.bool,
  usernameLabel: PropTypes.string,
  usernameInputProps: PropTypes.object,
  otpLabel: PropTypes.string,
  otpInputProps: PropTypes.object,
  onLogoClick: PropTypes.func,
};

AuthForm.defaultProps = {
  authState: 'LOGIN',
  showLogo: true,
  usernameLabel: 'Username',
  usernameInputProps: {
    type: 'string',
    placeholder: 'Email, Mobile or Username',
  },
  otpLabel: 'Please enter verification code',
  otpInputProps: {
    type: 'string',
    placeholder: 'OTP Code',
  },
  onLogoClick: () => {},
};

export default AuthForm;
